import React from 'react';
import ExecutiveBranch from '../executivebranch';

class ModeControl extends React.Component {

  render() {
    return (
      <div>
        <ExecutiveBranch from='ModeControl' menus={this.props.menus} openDrawer={this.props.openDrawer} />
      </div>
    );
  }
}

export default ModeControl;
